import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";

export default async function deleteObjetivo(id) {
  const endpoint = localStorage.getItem("endpoint");
  const url = endpoint + "glosario/" + id;

  try {
    const config = { method: "DELETE", headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.message === "Se eliminó el glosario correctamente") {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.success("Registro Eliminado");
    } else {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.error("No fue posible eliminar el elemento");
    }
  } catch (error) {
    alertify.error("Error inesperado");
  }
}
